let fallback = {};

export const setItem = function(key, val) {
  try {
    return localStorage.setItem(key, val);
  }
  catch (error) {
    fallback[key] = val;
    return void 0;
  }
};

export const getItem = function(key) {
  try {
    return localStorage.getItem(key);
  }
  catch (error) {
    return fallback[key] || null;
  }
};

export const removeItem = function(key) {
  try {
    return localStorage.removeItem(key);
  }
  catch (error) {
    delete fallback[key];
    return void 0;
  }
};

export const clear = function() {
  try {
    return localStorage.clear();
  }
  catch (error) {
    fallback = {};
    return void 0;
  }
};



// WEBPACK FOOTER //
// ./src/lib/local-storage.js